import { apiInstance, apiInstanceWithToken } from "../integrations/ApiInstance";
import "react-toastify/dist/ReactToastify.css";
import {
  authEndpoints,
  userEndpoints,
  userFamilyEndpoints,
  familyEndpoints,
  eventsEndpoints,
  addressEndpoints,
  translateTextEndpoints,
  configEndpoints,
  donationEndpoints,
  statementEndpoints,
} from "../integrations/ApiEndpoints";
import { getDataFromIndexDB, storeDataToIndexDB } from "../utils/dataStore";

const buildUrlWithQueryParams = (baseUrl, queryParams = {}) => {
  const url = new URL(baseUrl, window.location.origin); // Adjust base as needed
  Object.entries(queryParams).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      url.searchParams.append(key, value);
    }
  });
  return url.toString();
};

// // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //  USER/AUTH- START // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // 

export const Logout = async (logoutType) => {
  try {
    const email = await getDataFromIndexDB("email");
    let body = {};
    if (email) {
      body = JSON.stringify({ email, logoutType });
    }
    await apiInstanceWithToken.post(authEndpoints.logout, body);
    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
};
export const DeviceRegistration = async (body) => {
  try {
    await apiInstanceWithToken.post(authEndpoints.deviceRegistration, body);
    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
};
export const VerifyLogin = async (token, data) => {
  try {
    const response = await fetch(authEndpoints.verifyEmail, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      credentials: "include", // Store session cookie if backend supports
      body: data,
    });
    const dataOut = await response.json();

    if (!response.ok) {
      throw new Error(dataOut?.message || "பயனர் சரிபார்ப்பு தோல்வியடைந்தது...");

    }
    await storeDataToIndexDB("email", dataOut.user.email, Number(process.env.REACT_APP_AUTH_SESSION_EXPIRY_TIME));
    return dataOut; // Return the data if the family is successfully created
  } catch (error) {
    console.error(error);
    return false;
  }
};
export const GetWebAuthChallenge = async (email) => {
  try {
    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    };
    // Make the API call to the backend
    const response = await fetch(authEndpoints.challenge, requestOptions);
    if (!response.ok) {
      return { success: false, message: 'Failed to fetch webauth challenge' };
    }
    const data = await response.json(); // Parse the response body
    return { success: true, data }; // Return the parsed response
  } catch (error) {
    console.error(error);
    return { success: false, message: error.message || 'An error occurred while fetching the webauth challenge.' };
  }
};
export const UpdateWebAuthCredential = async (data) => {
  try {
    const response = await apiInstanceWithToken.put(authEndpoints.updateCredential, data);
    return response; // Return the data if the family is successfully created
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || 'குடும்பத்தை உருவாக்க முடியவில்லை' };
  }
};
export const UpdateBackendSession = async (data) => {
  try {
    const response = await apiInstanceWithToken.post(authEndpoints.updateBackendSession, data); // API endpoint to create family
    return response.data;
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || 'குடும்பத்தை உருவாக்க முடியவில்லை' };
  }
};
///EVENTS - START///////

// Fetch events
export const fetchUserEvents = async () => {
  try {
    const response = await apiInstance.get(eventsEndpoints.queryUserEvents);
    return response;
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "விவரத்தைப் பெறுவதில் தோல்வி..." };
  }
};
export const getUserEventById = async (id) => {
  try {
    const response = await apiInstance.get(eventsEndpoints.getUserEventById(id));
    return response;
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "விவரத்தைப் பெறுவதில் தோல்வி..." };
  }
};

// Fetch events
export const fetchEvents = async () => {
  try {
    const response = await apiInstanceWithToken.get(eventsEndpoints.queryEvents);
    return response;
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "விவரத்தைப் பெறுவதில் தோல்வி..." };
  }
};

// Create event
export const createEvent = async (eventData) => {
  try {
    const response = await apiInstanceWithToken.post(eventsEndpoints.createEvent, eventData);
    return response;
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "நிகழ்வை உருவாக்க முடியவில்லை..." };
  }
};

// Update event
export const updateEvent = async (id, eventData) => {
  try {
    const response = await apiInstanceWithToken.put(eventsEndpoints.updateEvent(id), eventData);
    return response;
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "நிகழ்வை புதுப்பிக்க முடியவில்லை..." };
  }
};

// Get single event
export const getEventById = async (id) => {
  try {
    const response = await apiInstanceWithToken.get(eventsEndpoints.getEventById(id));
    return response;
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "விவரத்தைப் பெறுவதில் தோல்வி..." };
  }
};
export const deleteEvent = async (id, eventData) => {
  try {
    const response = await apiInstanceWithToken.delete(eventsEndpoints.deleteEvent(id), eventData);
    return response;
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "நிகழ்வை புதுப்பிக்க முடியவில்லை..." };
  }
};

///EVENTS - END///////

// Fetch user profile (GET)
export const GetUser = async (email) => {
  try {
    const response = await apiInstanceWithToken.get(userEndpoints.details(email));
    return response; // Assuming the response contains user details
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "பயனர் சுயவிவரத்தைப் பெறுவதில் தோல்வி..." };
  }
};

export const getUserFamily = async (email) => {
  try {
    const response = await apiInstanceWithToken.get(userEndpoints.getUserFamily(email));
    return response; // Assuming the response contains user details
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "பயனர் சுயவிவரத்தைப் பெறுவதில் தோல்வி..." };
  }
};

export const getUserFamilyDonations = async (email) => {
  try {
    const response = await apiInstanceWithToken.get(userEndpoints.getUserFamilyDonations(email));
    return response; // Assuming the response contains user details
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "பயனர் சுயவிவரத்தைப் பெறுவதில் தோல்வி..." };
  }
};

export const getUserMessages = async (email) => {
  try {
    const response = await apiInstanceWithToken.get(userEndpoints.getMessages(email));
    return response; // Assuming the response contains user details
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "பயனர் செய்திகள் பெறுவதில் தோல்வி..." };
  }
};

// UPDATE USER
export const UpdateUser = async (updatedUserData) => {
  try {
    const response = await apiInstanceWithToken.put(userEndpoints.update, updatedUserData);
    return response; // Assuming the response contains the updated user data
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "பயனர் சுயவிவரத்தைப் புதுப்பிக்க முடியவில்லை..." };
  }
};
// UPDATE USER Address
export const updateUserAddress = async (updatedUserData,) => {
  try {
    const response = await apiInstanceWithToken.put(userEndpoints.updateUserAddress, updatedUserData);
    return response; // Assuming the response contains the updated user data
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "புதுப்பிக்க முடியவில்லை..." };
  }
};

export const checkMobileEligibility = async (checkUserData,) => {
  try {
    const response = await apiInstanceWithToken.put(userEndpoints.checkMobileEligibility, checkUserData);
    return response; // Assuming the response contains the updated user data
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "விவரத்தைப் பெறுவதில் தோல்வி..." };
  }
};

export const notifyMobileLinked = async (updatedUserData,) => {
  try {
    const response = await apiInstanceWithToken.put(userEndpoints.notifyMobileLinked, updatedUserData);
    return response; // Assuming the response contains the updated user data
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "புதுப்பிக்க முடியவில்லை..." };
  }
};

export const checkOtpValidatedSession = async (checkUserData,) => {
  try {
    const response = await apiInstanceWithToken.put(userEndpoints.checkOtpValidatedSession, checkUserData);
    return response; // Assuming the response contains the updated user data
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "விவரத்தைப் பெறுவதில் தோல்வி..." };
  }
};

export const notifyOtpValidatedSession = async (updatedUserData,) => {
  try {
    const response = await apiInstanceWithToken.put(userEndpoints.notifyOtpValidatedSession, updatedUserData);
    return response; // Assuming the response contains the updated user data
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "புதுப்பிக்க முடியவில்லை..." };
  }
};

export const updatePassword = async (updatedUserData,) => {
  try {
    const response = await apiInstanceWithToken.put(userEndpoints.updatePassword, updatedUserData);
    return response; // Assuming the response contains the updated user data
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "புதுப்பிக்க முடியவில்லை..." };
  }
};

// // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //  USER/AUTH- END // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // 

// // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // USER FAMILY- START // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // 
export const createUserFamily = async (familyData) => {
  try {
    const response = await apiInstanceWithToken.post(userFamilyEndpoints.createUserFamily, familyData); // API endpoint to create family
    return response; // Return the data if the family is successfully created
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || 'குடும்பத்தை உருவாக்க முடியவில்லை' };
  }
};


// Adjusted getUserFamilyById function
export const getUserFamilyById = async (id) => {
  try {
    // Make the GET request using the correct endpoint (queryFamilies is a string here)
    const response = await apiInstanceWithToken.get(userFamilyEndpoints.getUserFamilyById(id));
    return response; // Assuming the response contains recent families data
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "குடும்ப விவரங்களைப் பெற முடியவில்லை" };
  }
};

// UPDATE USER
export const updateUserFamily = async (updatedUserFamilyData) => {
  try {
    const response = await apiInstanceWithToken.put(userFamilyEndpoints.updateUserFamily, updatedUserFamilyData);
    return response; // Assuming the response contains the updated user data
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "குடும்பத்தைப் புதுப்பிக்க முடியவில்லை..." };
  }
};
// UPDATE USER
export const updateUserFamilyAddress = async (updatedUserFamilyData,) => {
  try {
    const response = await apiInstanceWithToken.put(userFamilyEndpoints.updateUserFamilyAddress, updatedUserFamilyData);
    return response; // Assuming the response contains the updated user data
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "குடும்பத்தைப் புதுப்பிக்க முடியவில்லை..." };
  }
};
export const createUserFamilyMember = async (familyMemberData,) => {

  try {
    const response = await apiInstanceWithToken.post(userFamilyEndpoints.createUserFamilyMember, familyMemberData); // API endpoint to create family
    return response; // Return the data if the family is successfully created
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "குடும்ப உறுப்பினரை உருவாக்க முடியவில்லை..." };  // Error handling
  }
};

// Adjusted getUserFamilyById function
export const getUserFamilyMemberById = async (id,) => {
  try {
    // Make the GET request using the correct endpoint (queryFamilies is a string here)
    const response = await apiInstanceWithToken.get(userFamilyEndpoints.getUserFamilyMemberById(id));

    return response; // Assuming the response contains recent families data
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "குடும்ப உறுப்பினர் விவரங்களைப் பெற முடியவில்லை..." };
  }
};

// UPDATE USER
export const updateUserFamilyMember = async (updatedUserFamilyMemberData,) => {
  try {
    const response = await apiInstanceWithToken.put(userFamilyEndpoints.updateUserFamilyMember, updatedUserFamilyMemberData);
    return response; // Assuming the response contains the updated user data
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "குடும்ப உறுப்பினரைப் புதுப்பிக்க முடியவில்லை..." };
  }
};


// // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // USER FAMILY - END // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // 


// // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //  FAMILY- START // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // 
export const createFamily = async (familyData) => {
  try {
    const response = await apiInstanceWithToken.post(familyEndpoints.createFamily, familyData); // API endpoint to create family
    return response; // Return the data if the family is successfully created
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || 'குடும்பத்தை உருவாக்க முடியவில்லை' };
  }
};


// Adjusted getRecentFamilies function
export const getRecentFamilies = async (status) => {
  try {
    // Make the GET request using the correct endpoint (queryFamilies is a string here)
    const response = await apiInstanceWithToken.get(familyEndpoints.queryFamilies, { params: { status } });
    return response; // Assuming the response contains recent families data
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "சமீபத்திய குடும்பங்களைப் பெறுவதில் தோல்வி" };
  }
};

// Adjusted getFamilyById function
export const getFamilyById = async (id) => {
  try {
    // Make the GET request using the correct endpoint (queryFamilies is a string here)
    const response = await apiInstanceWithToken.get(familyEndpoints.getFamilyById(id));
    return response; // Assuming the response contains recent families data
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "குடும்ப விவரங்களைப் பெற முடியவில்லை" };
  }
};

// UPDATE USER
export const updateFamily = async (updatedFamilyData) => {
  try {
    const response = await apiInstanceWithToken.put(familyEndpoints.updateFamily, updatedFamilyData);
    return response; // Assuming the response contains the updated user data
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "குடும்பத்தைப் புதுப்பிக்க முடியவில்லை..." };
  }
};
// UPDATE FAMILY ADDRESS
export const updateFamilyAddress = async (updatedFamilyData,) => {
  try {
    const response = await apiInstanceWithToken.put(familyEndpoints.updateFamilyAddress, updatedFamilyData);
    return response; // Assuming the response contains the updated user data
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "குடும்பத்தைப் புதுப்பிக்க முடியவில்லை..." };
  }
};

// Activate Family 
export const activateFamily = async (data,) => {
  try {
    const response = await apiInstanceWithToken.put(familyEndpoints.activateFamily, data);
    return response; // Assuming the response contains the updated user data
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "குடும்பத்தைப் செயல்படுத்த முடியவில்லை..." };
  }
};
// // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //  FAMILY- END // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // 

// // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //  FAMILY MEMBER- START // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // 
export const createFamilyMember = async (familyMemberData,) => {

  try {
    const response = await apiInstanceWithToken.post(familyEndpoints.createFamilyMember, familyMemberData); // API endpoint to create family
    return response; // Return the data if the family is successfully created
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "குடும்ப உறுப்பினரை உருவாக்க முடியவில்லை..." };  // Error handling
  }
};

// Adjusted getFamilyById function
export const getFamilyMemberById = async (id,) => {
  try {
    // Make the GET request using the correct endpoint (queryFamilies is a string here)
    const response = await apiInstanceWithToken.get(familyEndpoints.getFamilyMemberById(id));

    return response; // Assuming the response contains recent families data
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "குடும்ப உறுப்பினர் விவரங்களைப் பெற முடியவில்லை..." };
  }
};

// UPDATE USER
export const updateFamilyMember = async (updatedFamilyMemberData,) => {
  try {
    const response = await apiInstanceWithToken.put(familyEndpoints.updateFamilyMember, updatedFamilyMemberData);
    return response; // Assuming the response contains the updated user data
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "குடும்ப உறுப்பினரைப் புதுப்பிக்க முடியவில்லை..." };
  }
};

// Activate family member
export const activateFamilyMember = async (activtedFamilyMemberData,) => {
  try {
    const response = await apiInstanceWithToken.put(familyEndpoints.activateFamilyMember, activtedFamilyMemberData);
    return response; // Assuming the response contains the updated user data
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "குடும்ப உறுப்பினரைப் செயல்படுத்த முடியவில்லை..." };
  }
};

// Bulk Move family members
export const bulkMoveFamilyMembers = async (data,) => {
  try {
    const response = await apiInstanceWithToken.post(familyEndpoints.bulkMoveFamilyMembers, data);
    return response; // Assuming the response contains the updated user data
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "குடும்ப உறுப்பினரை நகர்த்த முடியவில்லை...." };
  }
};
// // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //  FAMILY MEMBER- END // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // 
// // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //  FAMILY QUERY- START // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // 

export const queryFamiliesByFamilyIdRange = async (queryParams = {}) => {
  try {
    const finalUrl = buildUrlWithQueryParams(familyEndpoints.queryFamiliesByFamilyIdRange, queryParams);
    // Make the GET request using the correct endpoint (queryFamilies is a string here)
    const response = await apiInstanceWithToken.get(finalUrl);

    return response; // Assuming the response contains recent families data
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "குடும்ப விவரங்களைப் பெற முடியவில்லை..." };
  }
};

export const queryFamiliesByArea = async (queryParams = {}) => {
  try {
    const finalUrl = buildUrlWithQueryParams(familyEndpoints.queryFamiliesByArea, queryParams);

    // Make the GET request using the correct endpoint (queryFamilies is a string here)
    const response = await apiInstanceWithToken.get(finalUrl);

    return response; // Assuming the response contains recent families data
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "குடும்ப விவரங்களைப் பெற முடியவில்லை..." };
  }
};
export const queryFamilyMembers = async () => {
  try {
    const finalUrl = buildUrlWithQueryParams(familyEndpoints.queryFamilyMembers);

    // Make the GET request using the correct endpoint (queryFamilies is a string here)
    const response = await apiInstanceWithToken.get(finalUrl);

    return response; // Assuming the response contains recent families data
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "குடும்ப விவரங்களைப் பெற முடியவில்லை..." };
  }
};
export const queryFamiliesCount = async (queryParams = {}) => {
  try {
    const finalUrl = buildUrlWithQueryParams(familyEndpoints.queryFamiliesCount, queryParams);

    // Make the GET request using the correct endpoint (queryFamilies is a string here)
    const response = await apiInstanceWithToken.get(finalUrl);

    return response; // Assuming the response contains recent families data
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "குடும்ப விவரங்களைப் பெற முடியவில்லை..." };
  }
};
// // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //  FAMILY QUERY- END // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // 



// // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //  Address Area- START // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // 
export const createAddressArea = async (addressAreaData,) => {

  try {
    const response = await apiInstanceWithToken.post(addressEndpoints.createAddressArea, addressAreaData); // API endpoint to create addressArea
    return response; // Return the data if the address Area is successfully created
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "முகவரியைப் உருவாக்க முடியவில்லை" };  // Error handling
  }
};

// Adjusted getAddressAreaById function
export const getAddressAreaByPin = async (pincode, withSubAreasOnly) => {

  try {
    // Make the GET request using the correct endpoint (queryAddressAreaes is a string here)
    const response = await apiInstanceWithToken.get(addressEndpoints.getAddressAreaByPin(pincode, withSubAreasOnly));
    return response; // Assuming the response contains recent AddressAreaes data
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "முகவரியைப் பெற முடியவில்லை." };
  }
};

// UPDATE USER
export const updateAddressArea = async (updatedAddressAreaData,) => {
  try {
    const response = await apiInstanceWithToken.put(addressEndpoints.updateAddressArea, updatedAddressAreaData);
    return response; // Assuming the response contains the updated user data
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "முகவரியைப் புதுப்பிக்க முடியவில்லை..." };
  }
};

export const updateAddressSubArea = async (updatedAddressSubAreaData,) => {
  try {
    const response = await apiInstanceWithToken.put(addressEndpoints.updateAddressSubArea, updatedAddressSubAreaData);
    return response; // Assuming the response contains the updated user data
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "முகவரியைப் புதுப்பிக்க முடியவில்லை..." };
  }
};

// Adjusted getAddressAreaById function
export const getUsedAddressArea = async () => {

  try {
    // Make the GET request using the correct endpoint (queryAddressAreaes is a string here)
    const response = await apiInstanceWithToken.get(addressEndpoints.getUsedAddressArea());
    return response; // Assuming the response contains recent AddressAreaes data
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "முகவரியைப் பெற முடியவில்லை." };
  }
};
// // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //  Address Area- END // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // 

// // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //  UTIL- START // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // 
export const translateText = async (TranslationData,) => {
  try {
    const response = await apiInstanceWithToken.post(translateTextEndpoints.translateText, TranslationData); // API endpoint to create addressArea
    return response; // Return the data if the address Area is successfully created
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "மொழிபெயர்ப்பு தோல்வியடைந்தது." };  // Error handling
  }
};
// // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //  UTIL- END // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // 

// // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //  CONFIG- START // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // 
export const createCategoryConfig = async (createCategoryConfigData,) => {
  try {
    const response = await apiInstanceWithToken.post(configEndpoints.createCategoryConfig, createCategoryConfigData); // API endpoint to create addressArea
    return response;
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "தோல்வியடைந்தது." };  // Error handling
  }
};
export const queryCategoryConfig = async (queryCategoryConfigData,) => {
  try {
    const response = await apiInstanceWithToken.post(configEndpoints.queryCategoryConfig, queryCategoryConfigData); // API endpoint to create addressArea
    return response;
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "தோல்வியடைந்தது." };  // Error handling
  }
};
export const queryExpenseCategoryConfig = async (queryCategoryConfigData,) => {
  try {
    const response = await apiInstanceWithToken.post(configEndpoints.queryExpenseCategoryConfig, queryCategoryConfigData); // API endpoint to create addressArea
    return response;
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "தோல்வியடைந்தது." };  // Error handling
  }
};
// // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //  CONFIG- END // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // 

// // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //  DONATION- START // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // 
export const createDonation = async (donationData) => {
  try {
    const response = await apiInstanceWithToken.post(donationEndpoints.createDonation, donationData); // API endpoint to create family
    return response;
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || ' உருவாக்க முடியவில்லை' };
  }
};
export const createGuestDonation = async (donationData) => {
  try {
    const response = await apiInstanceWithToken.post(donationEndpoints.createGuestDonation, donationData); // API endpoint to create family
    return response;
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || ' உருவாக்க முடியவில்லை' };
  }
};
export const getRecentDonations = async () => {
  try {
    const response = await apiInstanceWithToken.get(donationEndpoints.queryDonations);
    return response;
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "சமீபத்திய பெறுவதில் தோல்வி" };
  }
};

export const queryFamilyForDonation = async (data) => {
  try {
    // Make the GET request using the correct endpoint (queryFamilies is a string here)
    const response = await apiInstanceWithToken.post(donationEndpoints.queryFamilyForDonation, data);
    return response; // Assuming the response contains recent families data
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || " விவரங்களைப் பெற முடியவில்லை" };
  }
};
export const queryGuestForDonation = async (data) => {
  try {
    // Make the GET request using the correct endpoint (queryFamilies is a string here)
    const response = await apiInstanceWithToken.post(donationEndpoints.queryGuestForDonation, data);
    return response; // Assuming the response contains recent families data
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || " விவரங்களைப் பெற முடியவில்லை" };
  }
};

// UPDATE USER
export const updateDonation = async (updatedDonationData) => {
  try {
    const response = await apiInstanceWithToken.put(donationEndpoints.updateDonation, updatedDonationData);
    return response; // Assuming the response contains the updated user data
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || " புதுப்பிக்க முடியவில்லை..." };
  }
};

export const getFamilyDonations = async (data) => {
  try {
    // Make the GET request using the correct endpoint (queryFamilies is a string here)
    const response = await apiInstanceWithToken.post(donationEndpoints.getFamilyDonations, data);
    return response; // Assuming the response contains recent families data
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || " விவரங்களைப் பெற முடியவில்லை" };
  }
};

export const getCategoryDonations = async (data) => {
  try {
    // Make the GET request using the correct endpoint (queryFamilies is a string here)
    const response = await apiInstanceWithToken.post(donationEndpoints.getCategoryDonations, data);
    return response; // Assuming the response contains recent families data
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || " விவரங்களைப் பெற முடியவில்லை" };
  }
};

// // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //  DONATION- END // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // 
// // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //  MONEY- START // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // 
export const getMonthlyStatement = async (data) => {
  try {
    // Make the GET request using the correct endpoint (queryFamilies is a string here)
    const response = await apiInstanceWithToken.get(statementEndpoints.getMonthlyStatement, { params: data });
    if (response?.status === 200) {
      return response.data;
    }
    return response; // Assuming the response contains recent families data
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || " விவரங்களைப் பெற முடியவில்லை" };
  }
};

export const getDonationStatement = async (data) => {
  try {
    // Make the GET request using the correct endpoint (queryFamilies is a string here)
    const response = await apiInstanceWithToken.get(statementEndpoints.getDonationStatement, { params: data });
    if (response?.status === 200) {
      return response.data;
    }
    return response; // Assuming the response contains recent families data
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || " விவரங்களைப் பெற முடியவில்லை" };
  }
};

// // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //  MONEY- END // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // 